import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["disabled"];
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", {
    class: "counter__icon counter__icon--minus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_3 = [
    _hoisted_2
];
var _hoisted_4 = ["id", "name", "value", "min", "max", "step"];
var _hoisted_5 = { class: "counter__display" };
var _hoisted_6 = ["disabled"];
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", {
    class: "counter__icon counter__icon--plus",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_8 = [
    _hoisted_7
];
import { ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CounterControl',
    props: {
        name: {},
        defaultValue: { default: 0 },
        modelValue: { default: 0 },
        min: { default: 0 },
        max: { default: Number.MAX_SAFE_INTEGER },
        step: { default: 1 },
        size: { default: 'medium' }
    },
    emits: ["update:modelValue"],
    setup: function (__props, _a) {
        var emits = _a.emit;
        var props = __props;
        var value = ref(props.defaultValue);
        watch(function () { return props.modelValue; }, function (newValue) {
            if (value.value !== newValue) {
                value.value = newValue;
            }
        });
        var increment = function () {
            if (value.value + props.step <= props.max) {
                value.value += props.step;
                emits('update:modelValue', value.value);
            }
        };
        var decrement = function () {
            if (value.value - props.step >= props.min) {
                value.value -= props.step;
                emits('update:modelValue', value.value);
            }
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass({
                    counter: true,
                    'counter--small': props.size === 'small',
                })
            }, [
                _createElementVNode("button", {
                    disabled: (value.value - _ctx.step) < _ctx.min,
                    type: "button",
                    "aria-label": "Decrement",
                    class: "button button--icon button--round button--primary",
                    onClick: decrement
                }, _hoisted_3, 8 /* PROPS */, _hoisted_1),
                _createElementVNode("input", {
                    id: _ctx.name,
                    name: _ctx.name,
                    type: "number",
                    value: value.value,
                    min: _ctx.min,
                    max: _ctx.max,
                    step: _ctx.step,
                    readonly: ""
                }, null, 8 /* PROPS */, _hoisted_4),
                _createElementVNode("p", _hoisted_5, _toDisplayString(value.value), 1 /* TEXT */),
                _createElementVNode("button", {
                    disabled: (value.value + _ctx.step) > _ctx.max,
                    type: "button",
                    "aria-label": "Increment",
                    class: "button button--icon button--round button--primary",
                    onClick: increment
                }, _hoisted_8, 8 /* PROPS */, _hoisted_6)
            ], 2 /* CLASS */));
        };
    }
});
